// @ts-nocheck

export const localeCodes =  [
  "en",
  "nl",
  "de",
  "fr",
  "es",
  "sv",
  "da",
  "it",
  "pl",
  "pt",
  "fi",
  "no",
  "cs"
]
export const localeLoaders = {
  en: [],
  nl: [],
  de: [],
  fr: [],
  es: [],
  sv: [],
  da: [],
  it: [],
  pl: [],
  pt: [],
  fi: [],
  no: [],
  cs: []
}
export const vueI18nConfigs = []
export const normalizedLocales = [
  {
    code: "en",
    language: "en"
  },
  {
    code: "nl",
    language: "nl"
  },
  {
    code: "de",
    language: "de"
  },
  {
    code: "fr",
    language: "fr"
  },
  {
    code: "es",
    language: "es"
  },
  {
    code: "sv",
    language: "sv"
  },
  {
    code: "da",
    language: "da"
  },
  {
    code: "it",
    language: "it"
  },
  {
    code: "pl",
    language: "pl"
  },
  {
    code: "pt",
    language: "pt"
  },
  {
    code: "fi",
    language: "fi"
  },
  {
    code: "no",
    language: "no"
  },
  {
    code: "cs",
    language: "cs"
  }
]

